<template>
    <div class="g-seven-edit">
        <el-dialog
            class="arriveDialog"
            title="抵达"
            :close-on-click-modal="false"
            width="350px"
            :visible.sync="arriveVisiable"
            :before-close="handleClose">
            <el-form
            :label-position="'right'"
            :model="AdmittRuleForm"
            label-width="70px"
            ref="AdmittRuleForm"
            class="rowIndex"
            >
             <el-form-item
                label="发车单号"
                prop="dispatchNo"
                class="label-form"
                >
                <el-input
                    clearable
                    :disabled="true"
                    v-model.trim="AdmittRuleForm.dispatchNo"
                    size="mini"
                    class="dispatch"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="发车时间"
                prop="depTime"
                class="label-form"
                >
                <el-date-picker
                    v-model="AdmittRuleForm.depTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                    :picker-options="start_date"
                ></el-date-picker>
            </el-form-item>
            <el-form-item
                label="抵达时间"
                prop="arriTime"
                class="label-form"
                >
                <el-date-picker
                    v-model="AdmittRuleForm.arriTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                    :picker-options="end_date"
                ></el-date-picker>
            </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="dialog-btn" @click="handleClose">取 消</el-button>
                <el-button class="dialog-cel" type="primary" @click="saveOk">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getUpdateLists } from '../../../../api/vehicleFreePlatform';
export default {
    props: {
        arriveVisiable: {
            type: Boolean,
            default: false
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            AdmittRuleForm: {
                dispatchNo: '',
                depTime: '',
                arriTime: ''
            },
            start_date: {// 开始时间范围限定
                disabledDate: time => {
                    if (this.AdmittRuleForm.arriTime) {
                        return time.getTime() >= new Date(this.AdmittRuleForm.arriTime);
                    }
                }
            },
            end_date: {// 结束时间范围限定
                disabledDate: time => {
                    if (this.AdmittRuleForm.depTime) {
                        return time.getTime() <= new Date(this.AdmittRuleForm.depTime) - 8.64e6;
                    }
                }
            }
        };
    },
    methods: {
        handleClose() {
            this.$emit('update:arriveVisiable', false);
        },
        saveOk() {
            if (new Date(this.AdmittRuleForm.depTime) >= new Date(this.AdmittRuleForm.arriTime)) {
                return this.$message.warning('抵达时间必须大于发车时间，请重新设置时间！');
            }
            getUpdateLists(this.AdmittRuleForm).then(res => {
                if (res) {
                    this.$message.success('修改成功');
                    this.$emit('arriveSaveOk');
                }
            });
        }
    },
    mounted() {
        this.AdmittRuleForm.dispatchNo = this.rowData.dispatchNo;
        this.AdmittRuleForm.depTime = this.rowData.depTime;
        this.AdmittRuleForm.arriTime = this.rowData.arriTime;
    }
};
</script>
<style lang="less">
    @width: 220px;
    .dispatch{
        width: @width;
    }
</style>